import { useUserStore } from "~/stores/userStore"

export function useCookieConsentUpdate() {
  const userStore = useUserStore()

  if (userStore.current?.cookie_consent === "all") {
    useGAConsent("update", {
      ad_storage: "granted",
      analytics_storage: "granted",
    })
  } else {
    useGAConsent("update", {
      ad_storage: "denied",
      analytics_storage: "denied",
    })
  }
}
